import { useEffect, useState } from 'react';
import { loadOrth, hasOrth } from '../orth';

// Load the dialect's spelling table when the toggle is on. Returns null until it
// arrives — and if it never does. orthForm treats null as identity, so a failed
// fetch quietly leaves the book's spelling on the page instead of blanking the
// words, which is the right failure for a purely cosmetic overlay.
export default function useOrth(dialect, on) {
  const [table, setTable] = useState(null);
  useEffect(() => {
    if (!on || !hasOrth(dialect)) { setTable(null); return undefined; }
    let live = true;
    loadOrth(dialect).then((t) => { if (live) setTable(t); }).catch(() => {});
    return () => { live = false; };
  }, [dialect, on]);
  return table;
}
